"use-strict";

import httpClient from "../../../http/httpClient";

const httpOrganizer = (organizerId) => httpClient(`/organizers/${organizerId}`);

export default {
  loadAll: (page, pageSize, organizerId, name = "") =>
    httpOrganizer(organizerId).get(
      `/tournamentname?page=${page}&pageSize=${pageSize}&name=${name}`
    ),
  loadOne: (organizerId, tournamentId) =>
    httpOrganizer(organizerId).get(`/tournaments/${tournamentId}`),
  create: (organizerId, tournament) =>
    httpOrganizer(organizerId).post("/tournaments", tournament),
  update: (organizerId, tournamentId, tournament) =>
    httpOrganizer(organizerId).patch(
      `/tournaments/${tournamentId}`,
      tournament
    ),
  delete: (organizerId, tournamentId) =>
    httpOrganizer(organizerId).delete(`/tournaments/${tournamentId}`),
  loadRedCards: (page, pageSize, organizerId, tournamentId) =>
    httpOrganizer(organizerId).get(
      `/tournaments/${tournamentId}/incidences?type=RedCard&page=${page}&pageSize=${pageSize}`
    ),
  loadYellowCards: (page, pageSize, organizerId, tournamentId) =>
    httpOrganizer(organizerId).get(
      `/tournaments/${tournamentId}/incidences?type=YellowCard&page=${page}&pageSize=${pageSize}`
    ),
};
